import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="home">
      <div className="home-container">
        <h1 className="title">
          Dive into TypeScript magic master the basics in just 10
          minutes!
          <br />
          Welcome aboard 🚀
        </h1>
        <h2 className="home-subtitle">
          The most popular question Why choose TypeScript Over JavaScript? 🤷‍♂️🤔
        </h2>

        <h3>1-Why choose TypeScript Over JavaScript?</h3>

        <p>
          As a Software Engineer with extensive experience in the field of web
          development, my expertise has predominantly revolved around
          JavaScript. I've always found myself to be more adaptable when working
          with pure JavaScript. However, in recent years, I've noticed a
          recurring theme in job interviews: the question of whether I have
          experience with TypeScript and whether I understand the differences
          between TypeScript and JavaScript. My immediate response has always
          been that TypeScript is simply JavaScript with types, and I've long
          held the belief that knowing TypeScript wasn't essential as long as I
          was proficient in JavaScript. This perspective changed dramatically
          the moment I decided to delve into TypeScript documentation, and I
          encountered a specific example that completely altered my viewpoint.
          😢😁 This example wasn't just a revelation; it was the most compelling
          evidence that convinced me of TypeScript's indispensability. It's not
          merely an advantage; it's a necessity for any developer aiming to
          produce cleaner code and reduce the time spent on debugging and fixing
          errors. 🤯😤 The realization hit me hard: TypeScript is an obligation,
          not a bonus. It's a tool that every developer should embrace to
          enhance code quality and efficiency.
          <br />
          <br /> This is the example that I told you about it :
        </p>

        <img src="./img/example1.png" alt="example1" className="image" />

        <p>
          In this snippet of code I wish you all the best to define why the
          console.log dislay an error and return NaN
        </p>
        <p>
          <b>&#8594; The response </b>come in with typescript to alert you that
          there is a typo in the code even before the execution , and it's
          simple all you need is the correct the type in the height
        </p>

        <img
          src="./img/example2.png"
          alt="example1-reponse"
          className="image"
        />

        <p>
          <b>&#8594; Conclusion </b>TypeScript come to make the code almost
          clean and eliminate all sort of error !
        </p>

        <p>
          I dont want to waste more time , let diving into the basics of this
          language and try to catch the most important information to start
          working with typescript
        </p>

        <p>
          also you need to know that the first key of all developers is the
          documentation , I know sometimes it's too hard to read all the details
          of it but it's more efficient , you can visited &nbsp;
          <a
            href="https://www.typescriptlang.org/docs/handbook/typescript-from-scratch.html"
            target="_blank"
            rel="noopener noreferrer"
            className="typescriptDoc"
          >
            from here
          </a>
        </p>
        <div className="cercles">
          <Link to={"/basics"} className="link">
            <span className="basics">Basics</span>
          </Link>

          <Link to={"/react"} className="link">
            <span className="basics special">typeScript with React</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
